<template>
    <div class="row">
        <div class="col-12">
            <v-file-uploader :accept="['ddd']" v-model="value" multiple value-parameter="Files"></v-file-uploader>
        </div>
        <div class="col-12 mt-1" v-if="details.length != 0">
            <h3>Yükleme Sonuçları</h3>
            <div class="table-responsive mb-0">
                <table class="table table-sm table-bordered mb-0">
                    <thead>
                        <tr>
                            <th>Dosya Adı</th>
                            <th>Detay</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(d,i) in details" >
                            <template v-for="(info,ii) in d.Informations">
                                
                                <tr :key="i + ii">
                                    <td :rowspan="(d.Informations || []).length" v-if="ii == 0" class="font-weight-bolder">{{d.FileName}}</td>
                                    <td>
                                        <template v-if="info.Status == 0">
                                            <span class="text-success">{{info.Information}}</span>
                                        </template>
                                        <template v-if="info.Status == 1">
                                            <span class="text-danger">{{info.Information}}</span>
                                        </template>
                                        <template v-if="info.Status == 2">
                                            <span class="text-warning">{{info.Information}}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object,
        details:{
            type:Array,
            default:[]
        }
    },
}
</script>

<style>

</style>